/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CittaRes } from '../../models/citta-res';

export interface LuoghiControllerFindManyCitta$Params {
  /**
   * Sigla Provincia
   */
  siglaProvincia: string;

  /**
   * Filter by active status (0 = inactive, 1 = active)
   */
  flagAttivo?: number;
}

export function luoghiControllerFindManyCitta(
  http: HttpClient,
  rootUrl: string,
  params: LuoghiControllerFindManyCitta$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<CittaRes>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindManyCitta.PATH,
    'get',
  );
  if (params) {
    rb.query('siglaProvincia', params.siglaProvincia, {});
    rb.query('flagAttivo', params.flagAttivo, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CittaRes>>;
      }),
    );
}

luoghiControllerFindManyCitta.PATH = '/luoghi/citta';
